// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ods-board-item-card-header-container {
  margin-bottom: 6px;
}

.ods-board-item-time {
  color: #90a1b9;
  font-size: 0.688rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 4px;
}

.ods-board-order-id {
  color: #45556c;
  font-weight: 600;
  font-size: 0.625rem;
  background-color: #f1f5f9;
  border-radius: 50px;
  padding: 2px 8px;
  width: max-content;
  margin-top: 6px;
}

.ods-board-item-token {
  font-size: 0.625rem;
  font-weight: 600;
  color: #1447e6;
  background-color: #eff6ff;
  border-radius: 50px;
  padding: 2px 8px;
  width: max-content;
  border: 1px solid #dbeafe;
}

.ods-board-item-kot-container {
  display: flex;
  align-items: center;
  display: flex;
  gap: 6px;
  margin-top: 6px;
}

.ods-board-sub-Order-type {
  font-size: 0.625rem;
  font-weight: 600;
  border-radius: 50px;
  padding: 2px 8px;
}

.ods-board-time-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ods-board-bell-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ods-board-item-customer-name-box {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 20px;
}

.ods-board-item-customer-name {
  font-size: 0.813rem;
  font-weight: 700;
  color: #333333;
}

.ods-board-item-customer-number {
  font-size: 0.688rem;
  font-weight: 500;
  color: #96a2b4;
}

.ods-board-item-avatar {
  background-color: #f1f5f9;
  color: #62748e;
  font-size: 0.625rem;
  font-weight: 700;
  height: 28px;
  width: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ods-board-item-source-icon {
  font-size: 0.625rem;
  font-weight: 700;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Sales Channel Badge Styles */
.ods-board-item-channel-wrapper {
  border-radius: 6px;
  font-size: 0.813rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ods-board-sales-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.ods-board-line-item-container {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.ods-board-item-number {
  font-size: 0.688rem;
  font-weight: 400;
}

.ods-board-esitmated-value {
  font-size: 0.688rem;
  font-weight: 400;
  color: #798097;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ods-estimated-price {
  font-size: 0.813rem;
  font-weight: 700;
  color: #0f172b;
  display: flex;
  align-items: center;
  gap: 4px;
}

.ods-cancel-order-container {
  margin-top: 10px;
}

.ods-board-rider-status {
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 1rem;
  width: 100%;
  padding: 6px;
}

.ods-rider-upper-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ods-board-agent-service {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.688rem;
}

.ods-rider-status {
  font-size: 0.563rem;
  font-weight: 500;
  padding: 2px 4px;
  border-radius: 50px;
}

.ods-rider-bottom-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.688rem;
  margin-top: 2px;
}

.ods-board-otp {
  font-weight: 700;
  color: #1447e6;
}

/* ── Dark theme ── */
.dark .ods-board-order-id {
  background-color: #1e293b;
  color: #94a3b8;
}

.dark .ods-board-item-token {
  background-color: #1e3a5f;
  color: #93c5fd;
  border-color: #1e40af;
}

.dark .ods-board-item-customer-name {
  color: #f1f5f9;
}

.dark .ods-board-item-customer-number {
  color: #64748b;
}

.dark .ods-board-item-avatar {
  background-color: #334155;
  color: #94a3b8;
}

.dark .ods-board-rider-status {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .ods-estimated-price {
  color: #f1f5f9;
}

.dark .ods-board-esitmated-value {
  color: #64748b;
}

.dark .ods-board-delivery-agent {
  color: #94a3b8;
}

.dark .ods-board-agent-name {
  color: #cbd5e1;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/BoardItem.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".ods-board-item-card-header-container {\n  margin-bottom: 6px;\n}\n\n.ods-board-item-time {\n  color: #90a1b9;\n  font-size: 0.688rem;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.ods-board-order-id {\n  color: #45556c;\n  font-weight: 600;\n  font-size: 0.625rem;\n  background-color: #f1f5f9;\n  border-radius: 50px;\n  padding: 2px 8px;\n  width: max-content;\n  margin-top: 6px;\n}\n\n.ods-board-item-token {\n  font-size: 0.625rem;\n  font-weight: 600;\n  color: #1447e6;\n  background-color: #eff6ff;\n  border-radius: 50px;\n  padding: 2px 8px;\n  width: max-content;\n  border: 1px solid #dbeafe;\n}\n\n.ods-board-item-kot-container {\n  display: flex;\n  align-items: center;\n  display: flex;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.ods-board-sub-Order-type {\n  font-size: 0.625rem;\n  font-weight: 600;\n  border-radius: 50px;\n  padding: 2px 8px;\n}\n\n.ods-board-time-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ods-board-bell-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ods-board-item-customer-name-box {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 20px;\n}\n\n.ods-board-item-customer-name {\n  font-size: 0.813rem;\n  font-weight: 700;\n  color: #333333;\n}\n\n.ods-board-item-customer-number {\n  font-size: 0.688rem;\n  font-weight: 500;\n  color: #96a2b4;\n}\n\n.ods-board-item-avatar {\n  background-color: #f1f5f9;\n  color: #62748e;\n  font-size: 0.625rem;\n  font-weight: 700;\n  height: 28px;\n  width: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ods-board-item-source-icon {\n  font-size: 0.625rem;\n  font-weight: 700;\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Sales Channel Badge Styles */\n.ods-board-item-channel-wrapper {\n  border-radius: 6px;\n  font-size: 0.813rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ods-board-sales-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.ods-board-line-item-container {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.ods-board-item-number {\n  font-size: 0.688rem;\n  font-weight: 400;\n}\n\n.ods-board-esitmated-value {\n  font-size: 0.688rem;\n  font-weight: 400;\n  color: #798097;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ods-estimated-price {\n  font-size: 0.813rem;\n  font-weight: 700;\n  color: #0f172b;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.ods-cancel-order-container {\n  margin-top: 10px;\n}\n\n.ods-board-rider-status {\n  background-color: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: 1rem;\n  width: 100%;\n  padding: 6px;\n}\n\n.ods-rider-upper-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ods-board-agent-service {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.688rem;\n}\n\n.ods-rider-status {\n  font-size: 0.563rem;\n  font-weight: 500;\n  padding: 2px 4px;\n  border-radius: 50px;\n}\n\n.ods-rider-bottom-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.688rem;\n  margin-top: 2px;\n}\n\n.ods-board-otp {\n  font-weight: 700;\n  color: #1447e6;\n}\n\n/* ── Dark theme ── */\n.dark .ods-board-order-id {\n  background-color: #1e293b;\n  color: #94a3b8;\n}\n\n.dark .ods-board-item-token {\n  background-color: #1e3a5f;\n  color: #93c5fd;\n  border-color: #1e40af;\n}\n\n.dark .ods-board-item-customer-name {\n  color: #f1f5f9;\n}\n\n.dark .ods-board-item-customer-number {\n  color: #64748b;\n}\n\n.dark .ods-board-item-avatar {\n  background-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .ods-board-rider-status {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .ods-estimated-price {\n  color: #f1f5f9;\n}\n\n.dark .ods-board-esitmated-value {\n  color: #64748b;\n}\n\n.dark .ods-board-delivery-agent {\n  color: #94a3b8;\n}\n\n.dark .ods-board-agent-name {\n  color: #cbd5e1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
